"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var Content = function Content(_ref) {
  var content = _ref.content,
      featuredImage = _ref.featuredImage,
      featuredImageAltText = _ref.featuredImageAltText,
      topicTitle = _ref.topicTitle;
  var trimmedContent = content ? _htmlParser.default.stripHtml(content.trim()).substr(0, 1000) : '';
  var hasAltText = featuredImageAltText && featuredImageAltText.trim() !== '';
  return (0, _preact.h)("div", {
    className: "search-result-content"
  }, (0, _preact.h)("p", {
    className: "search-result-content--text"
  }, trimmedContent), featuredImage && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(featuredImage),
    alt: hasAltText ? featuredImageAltText : topicTitle,
    className: "search-result-content--featured-image",
    role: hasAltText ? 'img' : 'presentation',
    "aria-hidden": !hasAltText,
    onError: function onError(e) {
      ;
      e.target.style.display = 'none';
    }
  }));
};

var _default = Content;
exports.default = _default;